/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { InputFormat as ChromaInputFormat } from '@iag-packages/chroma-react/lib/components';
import styled, { css } from 'styled-components';
import THEME from 'theme';

const HelpInfoCss = css`
  + div {
    .c-btn--link {
      text-decoration: unset;
      &:hover {
        all: unset;
        color: #e01a22;
      }
    }
  }
`;

const InputFormatWrapper = styled.div<{ displayHelpInfo: boolean }>`
  .c-input {
    border-radius: 6px;
    font-weight: 300;
    min-width: 100%;
    border: 1px solid ${THEME.FIELD.BORDER.INPUT} !important;
  }

  .c-input:hover {
    border-width: thin;
    border-color: ${THEME.FIELD.BORDER.DEFAULT};
  }
  .c-input:focus,
  .c-input:active {
    border: ${THEME.FIELD.BORDER.NORMAL} solid ${THEME.FIELD.BORDER.DARK} !important;
  }

  .is-valid {
    border: ${THEME.FIELD.BORDER.SELECTED} solid ${THEME.FIELD.BORDER.VALID} !important;
  }
  .is-invalid {
    border-width: ${THEME.FIELD.BORDER.NORMAL};
  }
  ${({ displayHelpInfo }) => displayHelpInfo && `${HelpInfoCss}`}
`;

type InputFormatProps = React.ComponentProps<typeof ChromaInputFormat> & {
  onChange: (v: string) => void;
};

export const InputFormat = ({
  onChange,
  helpInfo,
  ...props
}: InputFormatProps) => (
  <InputFormatWrapper displayHelpInfo={!!helpInfo}>
    <ChromaInputFormat
      required={false}
      onChange={(e: never, v: string) => onChange(v)}
      {...props}
    />
  </InputFormatWrapper>
);

export default InputFormat;
